import axios, { AxiosInstance } from 'axios';

import { Configuration } from 'src/Services/API/generated';
import {
  CreateHouseholdDto,
  HouseholdBalanceDto,
  HouseholdDto,
  HouseholdMemberDto,
  UpdateHouseholdDto,
} from 'src/types/household.types';

export class HouseholdsApi {
  private axiosInstance: AxiosInstance;

  constructor(configuration: Configuration) {
    this.axiosInstance = axios.create({
      baseURL: configuration.basePath ?? '',
      ...configuration.baseOptions,
    });
  }

  async listEligibleMembers(assetId: string): Promise<HouseholdMemberDto[]> {
    const { data } = await this.axiosInstance.get<HouseholdMemberDto[]>(
      `/assets/${assetId}/households/eligible-members`
    );
    return data;
  }

  async list(assetId: string): Promise<HouseholdDto[]> {
    const { data } = await this.axiosInstance.get<HouseholdDto[]>(`/assets/${assetId}/households`);
    return data;
  }

  async balances(assetId: string): Promise<HouseholdBalanceDto[]> {
    const { data } = await this.axiosInstance.get<HouseholdBalanceDto[]>(
      `/assets/${assetId}/households/balances`
    );
    return data;
  }

  async create(assetId: string, payload: CreateHouseholdDto): Promise<HouseholdDto> {
    const { data } = await this.axiosInstance.post<HouseholdDto>(
      `/assets/${assetId}/households`,
      payload
    );
    return data;
  }

  async update(
    assetId: string,
    householdId: string,
    payload: UpdateHouseholdDto
  ): Promise<HouseholdDto> {
    const { data } = await this.axiosInstance.patch<HouseholdDto>(
      `/assets/${assetId}/households/${householdId}`,
      payload
    );
    return data;
  }

  async delete(assetId: string, householdId: string): Promise<void> {
    await this.axiosInstance.delete(`/assets/${assetId}/households/${householdId}`);
  }
}
